/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

import { overflowEllipsis } from 'src/styles/mixins';

const FLEX_WRAP_MARGIN = gridSize() * 2;

export const Avatar = styled.div({
  marginRight: `${gridSize()}px`,
});

export const Details = styled.div({
  overflow: 'auto',
});

export const ActionsWrapper = styled.div(
  {
    marginTop: `-${FLEX_WRAP_MARGIN}px`,
    marginBottom: `${gridSize() * 2}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  ({ isStaticHeaderVisible }: { isStaticHeaderVisible: boolean }) => ({
    visibility: isStaticHeaderVisible ? 'visible' : 'hidden',
  })
);

export const PullRequestInfo = styled.div({
  textAlign: 'left',
});

export const PullRequestSummary = styled.small(
  {
    display: 'block',
    marginTop: `${gridSize() / 2}px`,
  },
  media.upToSmall(`
    max-width: ${gridSize() * 31}px;
  `),
  overflowEllipsis()
);

export const PullRequestAuthor = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    marginTop: `${FLEX_WRAP_MARGIN}px`,
    marginRight: `${gridSize()}px`,
  },
  media.upToSmall(`
    margin-right: 0;
  `)
);

export const ButtonsWrapper = styled.div({
  marginTop: `${FLEX_WRAP_MARGIN}px`,
});
